// extracted by mini-css-extract-plugin
export default {"aboutSection":"AboutSection_aboutSection__DrzSo","aboutItems":"AboutSection_aboutItems__iemZl","text":"AboutSection_text__eBeoX"};